const actions = {
  APP_BOOTSTRAP: 'APP_BOOTSTRAP',
  APP_BOOTSTRAP_SUCCESS: 'APP_BOOTSTRAP_SUCCESS',
  APP_BOOTSTRAP_ERROR: 'APP_BOOTSTRAP_ERROR',

  appBootstrap: () => ({
    type: actions.APP_BOOTSTRAP,
  }),

  appBootstrapSuccess: () => ({
    type: actions.APP_BOOTSTRAP_SUCCESS,
  }),

  appBootstrapError: () => ({
    type: actions.APP_BOOTSTRAP_ERROR,
  }),
};

export default actions;
